import H1 from './H1';
import H2 from './H2';
import H3 from './H3';
import H4 from './H4';
import Label from './Label';
import Link from './Link';
import P from './P';

export {
  H1,
  H2,
  H3,
  H4,
  Label,
  Link,
  P,
};
